module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    staticClass: "d-flex pt-2 px-4 jc-center ai-center"
  }, [_c('div', {
    staticClass: "flex-1 d-flex fd-column"
  }, [_c('span', {
    staticClass: "pa-0 font-size-20 font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Configuración de exportación")]), _c('span', {
    staticClass: "font-size-12 text-muted pl-0"
  }, [_vm._v("Selecciona el formato y las columnas a exportar")])]), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.descripcionPredefinido) ? _c('div', {
    staticClass: "mx-1 flex-1"
  }, [(_vm.descripcionPredefinido) ? _c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.reportesPredefinidos,
      "label": "Seleccionar tipo de listado",
      "dense": "",
      "solo": "",
      "item-text": "titulo",
      "item-value": "descripcion"
    },
    model: {
      value: (_vm.descripcionPredefinido),
      callback: function($$v) {
        _vm.descripcionPredefinido = $$v
      },
      expression: "descripcionPredefinido"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-tabs', {
    staticClass: "d-flex mt-1",
    attrs: {
      "dense": "dense",
      "color": "primary",
      "grow": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: "lista"
  }, [(_vm.countLengthColumns('ticket')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Ticket")])]) : _c('span', [_c('span', [_vm._v("Ticket")])])], 1), _c('v-tab', {
    key: "estados"
  }, [(_vm.countLengthColumns('estado')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Estados")])]) : _c('span', [_vm._v("Estados")])], 1), _c('v-tab', {
    key: "etapas"
  }, [(_vm.countLengthColumns('etapa')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Etapas")])]) : _c('span', [_vm._v("Etapas")])], 1), _c('v-tab', {
    key: "tiempos"
  }, [(_vm.countLengthColumns('tiempo')) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "dot": "dot"
    }
  }, [_c('span', [_vm._v("Tiempos")])]) : _c('span', [_vm._v("Tiempos")])], 1), _c('v-tab', {
    key: "orden"
  }, [(_vm.columnasAExportar.length) ? _c('v-badge', {
    attrs: {
      "color": "primary",
      "content": _vm.columnasAExportar.length
    }
  }, [_c('span', [_vm._v("Listo para exportar")])]) : _c('span', [_vm._v("Listo para exportar")])], 1)], 1), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 228px)' : 'calc(100vh - 180px)'
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "lista"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasTicket.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasTicket.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas del ticket'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasTicket
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasTicket),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasTicket = $$v
      },
      expression: "isColumnasAllSeleccionadasTicket"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasTicket), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "estados"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasEstados.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasEstados.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los estados'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasEstados
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasEstados),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasEstados = $$v
      },
      expression: "isColumnasAllSeleccionadasEstados"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasEstados), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "etapas"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasEtapas.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasEtapas.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de las etapas'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasEtapas
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasEtapas),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasEtapas = $$v
      },
      expression: "isColumnasAllSeleccionadasEtapas"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasEtapas), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "tiempos"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasTiempos.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No habilitaste ninguna opcion")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Para visualizar columnas habilita alguna opcion en la parte superior")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.columnasTiempos.length) ? _c('v-switch', {
    staticClass: "mx-4 my-2",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "color": "primary",
      "label": _vm.isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los tiempos'
    },
    on: {
      "change": _vm.seleccionarTodasLasColumnasTiempos
    },
    model: {
      value: (_vm.isColumnasAllSeleccionadasTiempos),
      callback: function($$v) {
        _vm.isColumnasAllSeleccionadasTiempos = $$v
      },
      expression: "isColumnasAllSeleccionadasTiempos"
    }
  }) : _vm._e()], 1), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, [_vm._l((_vm.columnasTiempos), function(item, i) {
    return [_c('v-list-item', {
      key: ("item-" + i),
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;

          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active,
              "dense": "dense",
              "color": "primary",
              "hide-details": "hide-details"
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('strong', {
            staticClass: "font-size-12"
          }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
            staticClass: "font-size-11 text-muted"
          }, [_vm._v("columna de " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-icon', {
            attrs: {
              "color": item.color,
              "size": "12"
            }
          }, [_vm._v("circle")])], 1)]
        }
      }], null, true)
    }), _c('v-divider')]
  })], 2)], 1)], 1)], 1), _c('v-tab-item', {
    key: "orden"
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [(!_vm.columnasAExportar.length) ? _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 mt-12"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No seleccionaste ninguna columna")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Regresa a la primera pestaña para seleccionar algunos")])], 1) : _c('div', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('lista-draggable', {
    attrs: {
      "options": _vm.optionDragable,
      "ghost-class": "ghost",
      "chosen-class": "chosen",
      "drag-class": "drag"
    },
    model: {
      value: (_vm.columnasAExportar),
      callback: function($$v) {
        _vm.columnasAExportar = $$v
      },
      expression: "columnasAExportar"
    }
  }, _vm._l((_vm.columnasAExportar), function(item, i) {
    return _c('v-list', {
      key: ("item-" + i),
      staticClass: "py-0"
    }, [_c('v-list-item', {
      attrs: {
        "value": item,
        "active-class": "secondary primary--text"
      },
      on: {
        "click": function () {}
      }
    }, [_c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": item.color,
        "size": "12"
      }
    }, [_vm._v("circle")])], 1), _c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', [_c('strong', {
      staticClass: "font-size-12"
    }, [_vm._v(_vm._s(item.nombre))])]), _c('v-list-item-subtitle', [_c('span', {
      staticClass: "font-size-11 grey--text"
    }, [_vm._v(_vm._s(item.descripcionType) + " / " + _vm._s(item.table))])])], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "fab": "fab",
        "color": "error",
        "x-small": "x-small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return (function () {
            _vm.columnasAExportar.splice(i, 1)
          })($event)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1)], 1), _c('v-list-item-action', {
      staticClass: "handle"
    }, [_c('v-btn', {
      attrs: {
        "icon": "icon",
        "small": "small"
      }
    }, [_c('v-icon', [_vm._v("drag_indicator")])], 1)], 1)], 1), _c('v-divider')], 1)
  }), 1)], 1)])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-1 d-flex mx-4"
  }, [_c('span'), _c('v-spacer'), _c('small', {
    staticClass: "font-size-11 font-weight-700"
  }, [_vm._v(_vm._s(_vm.columnasTicket.length + _vm.columnasEstados.length + _vm.columnasEtapas.length + _vm.columnasTiempos.length) + " columnas disp., " + _vm._s(_vm.columnasAExportar.length) + "  para descargar")])], 1), _c('div', {
    staticClass: "d-flex mt-1 mb-4 mx-4",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('v-btn', {
    class: {
      'mx-2': !_vm.isMovil
    },
    attrs: {
      "color": "error",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogExportar()
      }
    }
  }, [_vm._v("Cancelar exportacion")]), _c('v-spacer'), _c('v-btn', {
    class: {
      'mt-2': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchExportarReporte()
      }
    }
  }, [_vm._v("Exportar informacion")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db511a52","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_reporte_parametros_exportacion.vue
// module id = 530
// module chunks = 1